import React from 'react';
import {isMobile} from 'react-device-detect';
import {Desktop} from 'shared/components/Header/RoomPlanner/FloatingControls/Desktop';

export const FloatingButtons = () => {
    if (isMobile) {
        return null;
    }

    return <Desktop />;
};
